"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Builder() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [{
    label: "150+ verified builders"
  }, {
    label: "500+ floor plans"
  }, {
    label: "10+ counties served"
  }];
  return <section data-section-id="542" id="find-your-perfect-builder" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {}
        <div ref={imageRef} className={`relative h-[50vh] lg:h-auto overflow-hidden transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706309/img/new_home_construction.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706309/img/new_home_construction.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706309/img/new_home_construction.png-wvc-sizes" alt="Modern luxury home construction in central Ohio" loading="lazy" decoding="async" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-tr from-background/40 via-transparent to-transparent pointer-events-none" />
        </div>

        {}
        <div ref={contentRef} className={`relative flex items-center bg-background transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="w-full px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-24 flex flex-col gap-10">
            {}
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-8 bg-primary" />
              <span className="font-default text-xs tracking-widest uppercase font-bold" style={{
              color: "var(--primary)"
            }}>
                Expert Guidance
              </span>
            </div>

            {}
            <h1 className="font-default font-bold text-foreground text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95]" style={{
            letterSpacing: "-0.02em"
          }}>
              Find your perfect home builder.
            </h1>

            {}
            <p className="font-default text-base sm:text-lg text-foreground max-w-md leading-relaxed">
              Navigating the central Ohio housing market is complex. BUILDIQ provides the 
              transparency, data, and expert comparisons you need to select the right 
              partner for your dream home project with total confidence.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
              <Button asChild variant="ghost" className="h-auto px-0 py-2 justify-start text-foreground hover:bg-transparent hover:text-primary group">
                <Link to="#" className="flex items-center gap-3 border-b border-primary pb-2 transition-colors">
                  <span className="font-default text-base font-bold">Compare Builders</span>
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="ghost" className="h-auto px-0 py-2 justify-start text-foreground hover:bg-transparent hover:text-primary group">
                <Link to="#" className="flex items-center gap-3 border-b border-primary pb-2 transition-colors">
                  <span className="font-default text-base font-bold">View Floor Plans</span>
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-4 lg:mt-8 self-start lg:self-end">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2 font-default text-xs sm:text-sm text-foreground tabular-nums">
                {stats.map((stat, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                    {i > 0 && <span aria-hidden="true" className="inline-block h-1 w-1 rounded-md bg-primary" />}
                    <span>{stat.label}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}